import React from "react";
import { DoubleSide, FrontSide } from "three";
import { useSnapshot } from "valtio";
import { materialState } from "../../state";
import MaterialTextureLoader from "../loaders/MaterialTextureLoader";
import {mapMaterialProps} from './MaterialPropertyMaps';

const MaterialController = (item, newTextureSet, newMaterialProps, location, doubleSided) => {
  
  // load new texture set - format props - apply to material
  const updateMaterial = (newTextureSet, newMaterialProps, doubleSided) => {
    
    const materialsPrototype = item['material'];
    //const texturePath = location + 'Leather' + '/';
    const texturePath = location;
    
    MaterialTextureLoader(texturePath, newTextureSet, newMaterialProps, (newTextures) => {
      
      // set material defaults
      item['material'].copy(materialsPrototype);
      
      // apply textures
      newTextures.forEach((texture) => {
        texture.flipY = false;
        item['material'][texture.name] = texture;
      });
      
      // apply material props - update based mapping
      const mapMatProps = mapMaterialProps();
      
      Object.keys(newMaterialProps).forEach((prop) => {
        
        if (!mapMatProps.get(prop)) {
          item['material'][prop] = newMaterialProps[prop];
        } else {
          item['material'][prop] = (mapMatProps.get(prop)(newMaterialProps[prop]));
        }
      });

      // Double sided materials
      item['material'].side = doubleSided ? DoubleSide : FrontSide;
      console.log(item['material'].side);
      
      item['material'].needsUpdate = true;

      
    });
    
  }
  updateMaterial(newTextureSet, newMaterialProps, doubleSided);
}


export default MaterialController;
